import './projects.css';
import { Link } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.css';

import { library } from '@fortawesome/fontawesome-svg-core' 
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'

library.add(fas, far, fab)

export default function Projects() {
    return(
    <div className="container-fluid">
          <nav >
              <div className="d-flex justify-content-between md">
            <img src="/mlogo.png" alt="Mpho logo" title="Homepage" className="logo">
            </img>
            <ul>
        
              <li className="active"> <a href="/" title="Homepage">Home</a></li>
              <li> <Link to="/projects" title="Projects">Projects</Link></li>
              <li> <a href="/resume.pdf" title="Resume">Resume</a></li>
            </ul>
            </div>
          </nav>
          <p className="heading">Projects I've Worked On </p>
<div className="row mb-5">
            <div className="col d-none d-lg-block">
                <img src="./reactapp.png" id="mpho-projects" alt="weather-project-preview" className="img-fluid rounded weather-image"></img>
                </div>
                <div className="col">
                    <div className="project-description">
                    <h2 >
                        Weather Project
                    </h2>
                    <p className=" text-muted description" >
                This weather app project was built using react, users can enter any city name to get the 5-day weather forecast or simply click on the “Use Current Location” button to get their current location’s weather details, including temperature, wind speed, humidity, and more.  
                    </p>
                    <a href="https://reatrapp.netlify.app/" target="_blank" rel="noreferrer" title="weather project link" className=" button btn btn-branding-outline">Learn more</a>
                    </div>
                </div>
                <div className="row mt-5">
                    <div className="col">
                    <div className="description">
                        <h2 className="mb-5">
                            Guitar Lesson Website
                        </h2>
                        <p className="mb-5 text-muted description" >
                           The guitar signupwebsite was built using basic HTML and CSS The acoustic guitar is one of the most popular instruments for a reason. With it, countless artists have learned to express themselves through music. If this is your first time trying the guitar or the first instrument you've ever played and would like to learn take heart and sign up for lessons.
                        </p>
                        <a href="https://s3.amazonaws.com/shecodesio-production/challenge_submissions/files/002/115/019/original/learn_guitar.html?1709466622" target="_blank" rel="noreferrer" title="guitar website link" className=" button btn btn-branding-outline">Learn more</a>
                     </div>
                        </div>
                    <div className="col d-none d-lg-block">
                        <img src="./signupwebsite.png" alt="guitar-app-preview"  className="img-fluid rounded"></img>
                        </div>
                        </div>
                        <div className="row mb-5">
            <div className="col d-none d-lg-block">
                <img src="./responsivewebsite.png" id="mpho-projects" alt="weather-project-preview" className="img-fluid rounded weather "></img>
                </div>
                <div className="col">
                    <div className=" mt-5 responsive-description">
                    <h2 className="mt-5 mb-5">
                        Responsive Portfolio
                    </h2>
                    <p className="mb-5 text-muted description" >
This portfolio website is built using semantic HTML and modern CSS to deliver a clean, structured, and responsive user experience.
It features intuitive navigation and interactive elements designed to guide users seamlessly through the content.
Careful attention has been given to layout, typography, and visual hierarchy to ensure clarity and readability across devices.
The design prioritizes accessibility and performance while maintaining a polished, professional appearance.
Overall, the portfolio demonstrates strong front-end fundamentals and a user-centred approach to web design  
                    </p>
                    <a href="https://mpho-portfolio-d9f5d1.netlify.app/" target="_blank" rel="noreferrer" title="weather project link" className=" button btn btn-branding-outline">Learn more</a>
                    </div>
                </div>
                      </div>
                      </div>
                      <div className="contact-section mt-5">
   <h1>
    Lets get intouch!
</h1>
 <ul class="social-linkssmall">
  <li><a href="mailto:wendyxmabushe@gmail.com" class="email-link" rel="noreferrer"><FontAwesomeIcon icon="fa-solid fa-message" /></a></li>
  <li><a href="www.linkedin.com/in/mphomabushe" target="_blank" title="linkedin profile" rel="noreferrer"><FontAwesomeIcon icon="fa-brands fa-linkedin" /></a></li>
  <li><a href="https://github.com/MphoMabushe" target="_blank" title="github profile" rel="noreferrer"><FontAwesomeIcon icon="fa-brands fa-github" /></a></li>
  </ul>
  </div>
 <footer>
  This project was coded by <a href="https://www.instagram.com/mphomabushe/">Mpho Mabushe</a>,is <a href="https://github.com/MphoMabushe">open-sourced on Github</a> and<a href="https://app.netlify.com/teams/mphomabushe/projects"> hosted on Netlify</a>
  </footer>
</div>
    );
}